import { yupObject, yupString } from 'shared/utils/YupUtils';
import { InferType } from 'yup';

export type MediaServiceDTO = InferType<typeof mediaServiceSchema>;
export const mediaServiceSchema = yupObject({
  signed_url: yupString().required(),
});
